var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"width":"100%","height":_vm.height+'px',"src":_vm.iframeUrl,"id":"reportFrame","frameborder":"0"},on:{"click":_vm.changeUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }